import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import ToggleButton from 'vue-js-toggle-button'
import Multiselect from 'vue-multiselect'
import apiFn from './api/api'
import App from './App.vue'
import router from './router'
import store from './store'
import { focus } from '@/helpers/directives'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import './assets/scss/main.scss'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(ToggleButton)
Vue.component('multiselect', Multiselect)
Vue.directive('focus', focus)

const api = apiFn()

new Vue({
  router: router(api),
  store: store(api),
  render: h => h(App)
}).$mount('#app')
